/*
  Checks whether the form is filled out
*/

export const getUnfilledCompulsoryFields = () => {
  const storedDataJSON = localStorage.getItem("UpdatedDataArray");

  if (!storedDataJSON) {
    return [];
  }
  const storedData = JSON.parse(storedDataJSON);
  const unfilledFields = storedData
    .filter((item) => item["CompulsoryValue (per property)"] === "TRUE")
    .filter((item) => {
      const valueFilled = item["Value (per property)"]?.trim() !== "";
      const qualityFilled = item["Quality (per value)"]?.trim() !== "";
      const notesFilled = item["Notes (per property)"]?.trim() !== "";
      return !valueFilled || !qualityFilled || !notesFilled;
    })
    .map((item) => item.Property);
    // console.log("Unfilled fields:", unfilledFields);
  return unfilledFields;
};
